import { getJWTToken } from './auth-client';

// wraps fetch with automatic JWT auth header for all backend /api calls
export async function apiFetch(url, options = {}) {
  const token = await getJWTToken().catch(() => null);

  return fetch(url, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...options.headers,
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });
}
